import { render } from "./AuthPrefs.vue?vue&type=template&id=7dae0200&ts=true"
import script from "./AuthPrefs.vue?vue&type=script&lang=ts"
export * from "./AuthPrefs.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__